import { gql } from '../../../apollo/__generated__';

export const CREATE_EVENT = gql(`
  mutation CreateEvent($createEventInput: CreateEventInput!) {
    createEvent(createEventInput: $createEventInput) {
      id
      name
      description
      startAt
      endAt
    }
  }
`);
